const ReplaceMarkWithSpan = () => {
	// Select all <mark> elements in the document
	const marks = document.querySelectorAll('mark');
	if(marks) {
		marks.forEach(function(mark) {
			const span = document.createElement('span');
			span.innerHTML = mark.innerHTML;
			span.style.backgroundColor = mark.style.backgroundColor;
			span.style.color = mark.style.color;
			//span.style.display = "inline-block";
			span.className = mark.className;
			mark.parentNode.replaceChild(span, mark);
		});
	}
}

export default ReplaceMarkWithSpan;